import trim from "./trim.filter";

const trimModule = angular.module("app.filters.trim", []).filter("trim", trim);

export default trimModule;



// WEBPACK FOOTER //
// ./src/filters/trim/trim.module.js